import React from 'react';
import { useApp } from '../../contexts/AppContext';
import HomeChoicesSection from './Sections/HomeChoicesSection/HomeChoicesSection';
import pageStyles from '../../styles/pages.module.css';
import './OnboardingPage.css';

// Main component
const OnboardingPage = () => {
  const { currentProject } = useApp();

  if (!currentProject) {
    return (
      <div className="card">
        <h2>אנא בחר פרויקט</h2>
      </div>
    );
  }

  return (
    <div className={pageStyles.pageContainer}>
      <HomeChoicesSection />
    </div>
  );
};

export default OnboardingPage;
